import React, { HTMLAttributes } from 'react';

import { Button, Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphInformation as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphInformationProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphInformation: React.FC<ParagraphInformationProps> = ({
  entity,
}) => {
  const paragraphInformation = entity.toJS();
  const title = paragraphInformation.field_title[0].value;
  const body = paragraphInformation.field_body[0].processed || '';
  const link = paragraphInformation.field_link[0]?.alias || paragraphInformation.field_link[0]?.uri || '';
  const linkText = paragraphInformation.field_link[0]?.title || '';

  return (
    <div className="Paragraph ParagraphInformation">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="ParagraphInformation__wrapper">
              <h2 className="ParagraphInformation__title">{title}</h2>
              <WysiwygField html={body} className="ParagraphInformation__body" />
              {link && (
                <div className="magic-line magic-line--thick ParagraphInformation__link">
                  <Button
                    href={link}
                    primary={false}
                    className="Button--textual icon-after icon-arrow-right icon-variant-4"
                  >
                    {linkText}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphInformation;
